import { render, staticRenderFns } from "./ApproveConsignment.vue?vue&type=template&id=b499f95c&"
import script from "./ApproveConsignment.vue?vue&type=script&lang=js&"
export * from "./ApproveConsignment.vue?vue&type=script&lang=js&"
import style0 from "./ApproveConsignment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ApproveConsignment.vue"
export default component.exports